import { render, staticRenderFns } from "./NewsItemDetails.vue?vue&type=template&id=4696cc20&scoped=true&"
import script from "./NewsItemDetails.vue?vue&type=script&lang=js&"
export * from "./NewsItemDetails.vue?vue&type=script&lang=js&"
import style0 from "./NewsItemDetails.vue?vue&type=style&index=0&id=4696cc20&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4696cc20",
  null
  
)

export default component.exports